export default "__VITE_PUBLIC_ASSET__343415a4__"